<template>
  <section class="components-forum-feed">
    <div class="py-lg-3 container w-100">
      <form-group
        id="filter"
        v-model="filter"
        type="text"
        placeholder="Buscar"
        :icon="`${icon_map[10]}`"
        class="d-none d-lg-block"
      />
      <h4 class="text-start py-2">
        Categorias
      </h4>
      <div
        class="d-flex mt-0"
        v-for="(category, i) in categories"
        :key="'c' + i"
      >
        <category-item-feed
          class="w-100"
          :title="category.title"
          :icon="icon_map[category.id]"
          :selected="selectedCategoryId == category.id"
          @select-item="onSelect(category.id)"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import FormGroup from "../FormGroup.vue";
import CategoryItemFeed from "./CategoryItemFeed.vue";

export default {
  name: "CategoriesForumFeed",
  components: { CategoryItemFeed, FormGroup },
  computed: {
    ...mapState("forum", ["categories"]),
    icon_map() {
      return {
        1: "icon-file-music",
        2: "icon-mic",
        3: "icon-amplifier",
        4: "icon-violin",
        5: "icon-piano-keys-light",
        6: "icon-guitar-electric",
        7: "icon-guitar",
        8: "icon-guitar-acoustic",
        9: "icon-drums",
        10: "icon-search"
      };
    }
  },
  mounted() {
    this.$store.dispatch("forum/getCategories").then();
  },
  data() {
    return {
      selectedCategoryId: null,
      filter: ""
    };
  },
  props: {
    value: {
      type: Number,
      default: null
    }
  },
  watch: {
    value(v) {
      this.selectedCategoryId = v;
    },
    filter(newVal) {
      this.$emit("textFilter", { textFilter: newVal });
    }
  },
  methods: {
    onSelect(id) {
      if (this.selectedCategoryId) {
        if (this.selectedCategoryId == id) {
          this.selectedCategoryId = null;
        } else {
          this.selectedCategoryId = id;
        }
      } else {
        this.selectedCategoryId = id;
      }
      this.$emit("input", this.selectedCategoryId);
    }
  }
};
</script>

<style lang="scss">
.components-forum-feed {
  background-color: #111112;
  border-radius: 8px;

  .container {
    max-width: 300px;
  }

  .selected {
    background-color: #2db563;
  }

  .icon {
    line-height: 37px !important;
    left: 8px !important;
    color: #767676;
  }

  .form-control {
    min-height: 0 !important;
    height: 37px !important;
    background: transparent !important;
    border: 1px solid #767676;
    border-radius: 50px;
  }
}
</style>
